<iss-typeahead-select
  [formControl]="control.control"
  [items$]="items$"
  [loading$]="loading$"
  [placeholder]="'Added service'"
  [readonly]="readonly"
  [loading]="loading"
  [stringify]="stringify"
  [content]="content"
  [identity]="identity"
  [matcher]="matcher"
/>
